

import {
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    UPDATE_INVOICE_ATTACHMENTS_ADDITIONAL,
    UPDATE_INVOICE_ATTACHMENTS,
    // GET_INCOMING_INVOICES,
    // GET_OUTGOING_INVOICES,
    GET_INVOICES,
    GET_INVOICE,
    CLEAR_INVOICE,
    DELETE_INVOICE,
    CLEAR_INVOICES,
    SEND_NEW_INVOICE,
    SAVE_NEW_INVOICE_DRAFT,
    SEND_EX_INVOICE,
    SAVE_EX_INVOICE_DRAFT,
    TOGGLE_INVOICE_TAB,
    RESPOND_TO_INVOICE,
    START_INVOICE_REVISION,
    GET_INVOICE_HISTORY,
    GET_INVOICE_VERSIONS,
    GET_INVOICE_VERSION_DETAIL,
    CLEAR_INVOICE_VERSION_DETAIL,
    GET_INVOICE_WITHOUT_ATTACHMENTS,
    CLEAR_INVOICE_ATTACHMENTS,
    CLEAR_ALL_DROPS,
    GET_INVOICE_DROPS,
    SET_INVOICE_DROP,
    GET_INVOICES_INCLUDING_HIDDEN
} from "../actions/types";

const initialState = {
    invoices: [],
    noInvoicesExist: false,
    invoiceDrops: [],
    invoice: {},
    invoiceDrop: {},
    invoiceTabIncoming: true,
    versionDetail: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        // ensure no redux values linger between users ----
        case LOGIN_SUCCESS:
        case LOGOUT_SUCCESS:
        case LOGOUT_FAIL:
            return {
                ...initialState,
            };
        case GET_INVOICES_INCLUDING_HIDDEN:
        case GET_INVOICES:
            return {
                ...state,
                invoices: action.payload.invoices,
                noInvoicesExist: action.payload.invoices.length === 0 ? true : false,
                invoiceDrops: action.payload.invoiceDrops
            };
        case GET_INVOICE:
            return {
                ...state,
                invoice: action.payload.invoice,
                invoiceDrop: action.payload.invoiceDrop
            };
        case GET_INVOICE_WITHOUT_ATTACHMENTS:
            return {
                ...state,
                invoice: { ...action.payload.invoice, attachments: [], attachments_additional: [] },
                invoiceDrop: action.payload.invoiceDrop,
            };
        case CLEAR_INVOICE_ATTACHMENTS:
            return {
                ...state,
                invoice: { ...state.invoice, attachments: [], attachments_additional: [] }
            };
        case GET_INVOICE_HISTORY:
            return {
                ...state,
                invoice: { ...state.invoice, history: [...action.payload] }
            };
        case GET_INVOICE_VERSIONS:
            return {
                ...state,
                invoice: { ...state.invoice, versions: [...action.payload] }
            };
        case GET_INVOICE_VERSION_DETAIL:
            return {
                ...state,
                versionDetail: action.payload
            };
        case CLEAR_INVOICE_VERSION_DETAIL:
            return {
                ...state,
                versionDetail: {}
            };
        case SEND_NEW_INVOICE: 
            return {
                ...state,
                invoices: [...state.invoices, action.payload.newInvoice],
                invoice: action.payload.newInvoice,
                invoiceDrops: [...state.invoiceDrops, action.payload.newInvoiceDrop],
                noInvoicesExist: false,
            };
        case SAVE_NEW_INVOICE_DRAFT: 
            return {
                ...state,
                invoices: [...state.invoices, action.payload.newInvoice],
                invoice: [],
                invoiceDrops: [...state.invoiceDrops, action.payload.newInvoiceDrop],
                noInvoicesExist: false,
            };
        case SEND_EX_INVOICE: 
            return {
                ...state,
                invoices: state.invoices.map(invoice => invoice.invoice_id === action.payload.newInvoice.invoice_id ? {...invoice, ...action.payload.newInvoice} : invoice),
                invoice: action.payload.newInvoice,
                invoiceDrops: state.invoiceDrops.map(invoiceDrop => invoiceDrop.invoice_id === action.payload.newInvoiceDrop.invoice_id ? action.payload.newInvoiceDrop : invoiceDrop),
                noInvoicesExist: false,
            };
        case SAVE_EX_INVOICE_DRAFT: 
            return {
                ...state,
                invoices: state.invoices.map(invoice => invoice.invoice_id === action.payload.newInvoice.invoice_id ? {...invoice, ...action.payload.newInvoice} : invoice),
                invoice: [],
                invoiceDrops: state.invoiceDrops.map(invoiceDrop => invoiceDrop.invoice_id === action.payload.newInvoiceDrop.invoice_id ? action.payload.newInvoiceDrop : invoiceDrop),
                invoiceDrop: {},
                noInvoicesExist: false,
            };
        case RESPOND_TO_INVOICE:
            return {
                ...state,
                invoice: { ...state.invoice, ...action.payload },
                invoices: state.invoices.map(invoice => invoice.invoice_id === action.payload.invoice_id ? {...invoice, ...action.payload} : invoice),
            }
        case UPDATE_INVOICE_ATTACHMENTS:
            return {
                ...state,
                invoice: { ...state.invoice, attachments: action.payload }
            }
        case UPDATE_INVOICE_ATTACHMENTS_ADDITIONAL:
            return {
                ...state,
                invoice: { ...state.invoice, attachments_additional: action.payload }
            }
        case CLEAR_INVOICES:
            return {
                ...state,
                invoices: [],
                noInvoicesExist: false,
            }
        case CLEAR_INVOICE:
            return {
                ...state,
                invoice: {},
                invoiceDrop: {},
                versionDetail: {},
            }
        case DELETE_INVOICE:
            return {
                ...state,
                invoices: state.invoices.filter((invoice) => invoice.invoice_id !== action.payload),
                invoiceDrops: state.invoiceDrops.filter((invoice) => invoice.invoice_id !== action.payload),
                noInvoicesExist: state.invoices.length <= 1 ? true : false, 
                invoiceDrop: {}
            }
        case TOGGLE_INVOICE_TAB:
            return {
                ...state,
                invoiceTabIncoming: !state.invoiceTabIncoming
            };
        case START_INVOICE_REVISION:
            return {
                ...state,
                invoice: { ...this.state.invoice, version: (this.state.invoice.version + 1) }
            };
        case GET_INVOICE_DROPS:
            return {
                ...state,
                invoiceDrops: action.payload,
            };
        case CLEAR_ALL_DROPS:
            return {
                ...state,
                invoiceDrops: [],
            };
        case SET_INVOICE_DROP:
            return {
                ...state,
                invoiceDrop: action.payload,
            };

        default:
            return state;
    }
}
